export default __webpack_public_path__ + "566a190454dc7355b1922c5bf4bd9376.svg";